const filteringActionsPrefix = "filtering";

export const filteringActions = {
  MODAL_OPEN: `${filteringActionsPrefix}/modal-open`,
  MODAL_CLOSE: `${filteringActionsPrefix}/modal-close`,
  FORM_SUBMIT: `${filteringActionsPrefix}/form-submit`,
};
